import React, { Component } from 'react';
import './Login.css';

import Title from '../ui/Title.js';
import BodyText from '../ui/BodyText.js';
import FormError from '../ui/FormError.js';
import FormInput from '../ui/FormInput.js';
import DisabledFormInput from '../ui/DisabledFormInput.js';
import HelpLink from '../ui/HelpLink.js';
import Button from '../ui/Button.js';
import SmallText from '../ui/SmallText.js';
import Loading from '../ui/Loading.js';

class Login extends Component {

  constructor(props) {

    super(props);

    this.handleEnterKeyPress = this.handleEnterKeyPress.bind(this);

  }

  handleEnterKeyPress(event) {

    if(event.key === 'Enter'){
      this.props.onButtonClick(event)
    }

  }

  render() {

    return (
      <div className = "Login qtq-modal-content" onKeyPress={this.handleEnterKeyPress}>
        <Title
          label = {this.props.translationService.get('login.title')}
          onClose = {this.props.onClose}
          />
        <FormError
          text = {this.props.formError}
          />
        <DisabledFormInput
          value = {this.props.emailValue}
          />
        <FormInput
          type = 'password'
          placeholder = {this.props.translationService.get('form.password.label')}
          value = {this.props.passwordValue}
          errorMessage = {this.props.passwordErrorMessage}
          onChange = {this.props.onPasswordChange}
          />
        <HelpLink
          text = {this.props.translationService.get('form.forgotpassword.title')}
          onClick = {this.props.onPasswordHelpClick}
          />
        <FormInput
          type = 'checkbox'
          value = '1'
          onChange = {this.props.onRememberMeChange}
          label = {this.props.translationService.get('form.rememberme.label')}
          />
        {this.props.actionInProgress ? (
          <Loading/>
        ) : (
          <Button
            label = {this.props.translationService.get('actions.submit')}
            onClick = {this.props.onButtonClick}
            />
        )}
          <BodyText
              text = {this.props.translationService.get('login.bodytext')}
          />
        <SmallText
          text = {this.props.translationService.get('login.smalltext')}
          />
      </div>
    );

  }

}

export default Login;



// WEBPACK FOOTER //
// ./src/comps/Login.js